export const pushUrlWhiteList = [
  '20458',
  '25610',
  '912261',
  '14828587',
  '14187054',
  '14828580',
  '434692',
  '2956775',
  '14964657',
  '15029050',
  '15106151',
  '11230890',
  '15230103',
  '14965926',
  '14466524',
  '11337292',
  '11337292',
  '14839698',
  '14386135',
  '14573782',
  '14573787',
];

export const isInPushUrlWhiteList = () =>
  // pushUrlWhiteList.indexOf(window.pageProps.uid) >= 0
  true;

export const isShowLeadsSubSource =
  !!window.pageProps && (window.pageProps.uid === '3726909' || window.pageProps.uid === '718973');
